module.exports = __webpack_public_path__ + "img/HelpSeshQuestionMarkLogo1_BETA.0539a6e3.png";